(function () {
  var aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
    if (c.get || c.set) throw new TypeError("ES3 does not support getters and setters.");
    a != Array.prototype && a != Object.prototype && (a[b] = c.value);
  },
      ba = "undefined" != typeof window && window === this ? this : "undefined" != typeof global && null != global ? global : this;

  function ca(a, b) {
    if (b) {
      for (var c = ba, d = a.split("."), e = 0; e < d.length - 1; e++) {
        var f = d[e];
        f in c || (c[f] = {});
        c = c[f];
      }

      d = d[d.length - 1];
      e = c[d];
      f = b(e);
      f != e && null != f && aa(c, d, {
        configurable: !0,
        writable: !0,
        value: f
      });
    }
  }

  ca("String.prototype.includes", function (a) {
    return a ? a : function (b, a) {
      if (null == this) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return -1 !== (this + "").indexOf(b, a || 0);
    };
  });
  ca("Number.isFinite", function (a) {
    return a ? a : function (b) {
      return "number" !== typeof b ? !1 : !isNaN(b) && Infinity !== b && -Infinity !== b;
    };
  });
  ca("Number.isInteger", function (a) {
    return a ? a : function (b) {
      return Number.isFinite(b) ? b === Math.floor(b) : !1;
    };
  });

  function da(a) {
    var b = typeof a;
    if ("object" == b) {
      if (a) {
        if (a instanceof Array) return "array";
        if (a instanceof Object) return b;
        var c = Object.prototype.toString.call(a);
        if ("[object Window]" == c) return "object";
        if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
        if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
      } else return "null";
    } else if ("function" == b && "undefined" == typeof a.call) return "object";
    return b;
  }

  function ea(a, b, c) {
    return a.call.apply(a.bind, arguments);
  }

  function fa(a, b, c) {
    if (!a) throw Error();

    if (2 < arguments.length) {
      var d = Array.prototype.slice.call(arguments, 2);
      return function () {
        var c = Array.prototype.slice.call(arguments);
        Array.prototype.unshift.apply(c, d);
        return a.apply(b, c);
      };
    }

    return function () {
      return a.apply(b, arguments);
    };
  }

  function ga(a, b, c) {
    ga = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ea : fa;
    return ga.apply(null, arguments);
  }

  ;

  function h(a) {
    var b = [];
    ha(new ia(), a, b);
    return b.join("");
  }

  function ia() {}

  function ha(a, b, c) {
    if (null == b) c.push("null");else {
      if ("object" == typeof b) {
        if ("array" == da(b)) {
          var d = b;
          b = d.length;
          c.push("[");

          for (var e = "", f = 0; f < b; f++) {
            c.push(e), e = d[f], ha(a, e, c), e = ",";
          }

          c.push("]");
          return;
        }

        if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();else {
          c.push("{");
          f = "";

          for (d in b) {
            Object.prototype.hasOwnProperty.call(b, d) && (e = b[d], "function" != typeof e && (c.push(f), ja(d, c), c.push(":"), ha(a, e, c), f = ","));
          }

          c.push("}");
          return;
        }
      }

      switch (typeof b) {
        case "string":
          ja(b, c);
          break;

        case "number":
          c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");
          break;

        case "boolean":
          c.push(String(b));
          break;

        case "function":
          c.push("null");
          break;

        default:
          throw Error("Unknown type: " + typeof b);
      }
    }
  }

  var ka = {
    '"': '\\"',
    "\\": "\\\\",
    "/": "\\/",
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "\t": "\\t",
    "\x0B": "\\u000b"
  },
      la = /\uffff/.test("\uFFFF") ? /[\\\"\x00-\x1f\x7f-\uffff]/g : /[\\\"\x00-\x1f\x7f-\xff]/g;

  function ja(a, b) {
    b.push('"', a.replace(la, function (b) {
      var a = ka[b];
      a || (a = "\\u" + (b.charCodeAt(0) | 65536).toString(16).substr(1), ka[b] = a);
      return a;
    }), '"');
  }

  ;

  function n(a) {
    a = String(a);

    try {
      return JSON.parse(a);
    } catch (b) {}

    throw Error("Invalid JSON string: " + a);
  }

  function q(a) {
    try {
      return "object" === typeof JSON && "function" === typeof JSON.stringify ? JSON.stringify(a) : h(a);
    } catch (b) {}

    throw Error("Could not stringify object");
  }

  ;

  function ma() {
    function a() {
      if (b.length) b[0](function () {
        b.shift();
        a();
      });
    }

    var b = [];
    return function (c) {
      b.push(c);
      1 === b.length && a();
    };
  }

  ;
  var na = 2,
      oa = 200,
      pa = 5E3,
      r = "",
      u = {},
      qa = "undefined" !== typeof window && !!(window.performance && window.performance.timing && window.performance.timing.navigationStart),
      ra = "";

  function sa(a) {
    return a && "number" === typeof a ? (Date.now() - a).toString() : null;
  }

  var v = !1,
      ta = {
    "/v1/open": {
      link_identifier: "\\d+"
    },
    "/v1/pageview": {
      event: "pageview"
    },
    "/v1/dismiss": {
      event: "dismiss"
    }
  },
      ua = !1;

  function va(a, b) {
    var c = document.createElement("a");
    c.href = a;
    c = c.pathname;
    "/" != c[0] && (c = "/" + c);
    c = ta[c];
    if (!c) return !0;

    if (0 < Object.keys(c).length) {
      if (!b) return !0;

      for (var d in c) {
        var e = new RegExp(c[d]);
        if (!b.hasOwnProperty(d) || !e.test(b[d])) return !0;
      }
    }

    return !1;
  }

  function wa(a, b) {
    if (a || b) {
      for (var c = "https://bnc.lt/a/" + a + "?", d = "tags alias channel feature stage campaign type duration sdk source data".split(" "), e = 0; e < d.length; e++) {
        var f = d[e],
            k = b[f];
        if (k) if ("tags" === f && Array.isArray(k)) for (var g = 0; g < k.length; g++) {
          c = ("?" === c[c.length - 1] ? c + f : c + "&" + f) + "=" + encodeURIComponent(k[g]);
        } else if ("string" === typeof k && 0 < k.length || "number" === typeof k) "data" === f && "string" === typeof k && (k = xa(k)), c = ("?" === c[c.length - 1] ? c + f : c + "&" + f) + "=" + encodeURIComponent(k);
      }

      return c;
    }
  }

  function ya(a) {
    a && (a.ga = null, a.M = null, a.G = null, a.v = null, a.C = null, a.B = null, a.o && delete a.o, a.s && delete a.s, a.c.remove("branch_view_enabled"), za(a.c, {}, !0));
  }

  function w(a, b, c) {
    a = a.replace(/\$(\d)/g, function (a, c) {
      return b[parseInt(c, 10) - 1];
    });
    c && (a += "\n Failure Code:" + c);
    return a;
  }

  function Aa(a) {
    return {
      data: a.data || "",
      data_parsed: a.data_parsed || {},
      has_app: a.has_app || null,
      identity: a.identity || null,
      referring_identity: a.referring_identity || null,
      referring_link: a.referring_link || null
    };
  }

  function Ba(a) {
    var b = /^\$journeys_\S+$/,
        c = a.data,
        d = {};
    if (!c) return {};

    switch (typeof c) {
      case "string":
        try {
          c = n(c);
        } catch (e) {
          c = {};
        }

        break;

      case "object":
        break;

      default:
        c = {};
    }

    Object.keys(c).forEach(function (a) {
      b.test(a) && (d[a] = c[a]);
    });
    return d;
  }

  function Ca() {
    return x() ? document.referrer : String(window.location);
  }

  function Da(a) {
    a.source = "web-sdk";
    var b = a.data;

    switch (typeof b) {
      case "string":
        try {
          b = n(b);
        } catch (c) {
          b = {
            _bncNoEval: !0
          };
        }

        break;

      case "object":
        break;

      default:
        b = {};
    }

    b.$canonical_url || (b.$canonical_url = Ca());
    b.$og_title || (b.$og_title = y("title"));
    b.$og_description || (b.$og_description = y("description"));
    b.$og_image_url || (b.$og_image_url = y("image"));
    b.$og_video || (b.$og_video = y("video"));
    b.$og_type || (b.$og_type = y("type"));
    "string" === typeof b.$desktop_url && (b.$desktop_url = b.$desktop_url.replace(/#r:[a-z0-9-_]+$/i, "").replace(/([\?\&]_branch_match_id=\d+)/, ""));

    try {
      n(b);
    } catch (c) {
      b = h(b);
    }

    a.data = b;
    return a;
  }

  function Ea(a) {
    function b(b) {
      return "" !== b;
    }

    if (!a || "string" !== typeof a) return "";
    var c = document.createElement("a");
    c.href = a;
    a = c.pathname && c.pathname.split("/").filter(b);
    return Array.isArray(a) && a.length ? a[a.length - 1] + c.search : c.search;
  }

  function z(a, b) {
    a && "object" === typeof a || (a = {});
    if (!b || "object" !== typeof b) return a;

    for (var c in b) {
      b.hasOwnProperty(c) && (a[c] = b[c]);
    }

    return a;
  }

  function Fa() {
    try {
      var a = (x() && Ga() ? window.top.location.hash : window.location.hash).match(/r:([^&]*)/);
      if (a && 1 <= a.length) return a[1];
    } catch (b) {}
  }

  function Ha(a) {
    return !!/^((?!chrome|android|crios|fxios).)*safari/i.test(a);
  }

  function Ia(a, b) {
    b = b || 11;
    var c = /version\/([^ ]*)/i.exec(a);
    if (c && c[1]) try {
      if (parseFloat(c[1]) >= b) return !0;
    } catch (d) {}
    return !1;
  }

  function A() {
    var a = navigator.userAgent;
    return a.match(/android/i) ? "android" : a.match(/ipad/i) || a && Ha(a) && a && -1 < a.indexOf("Macintosh") && Ia(a, 13) && screen.height > screen.width ? "ipad" : a.match(/i(os|p(hone|od))/i) ? "ios" : a.match(/\(BB[1-9][0-9]*\;/i) ? "blackberry" : a.match(/Windows Phone/i) ? "windows_phone" : a.match(/Kindle/i) || a.match(/Silk/i) || a.match(/KFTT/i) || a.match(/KFOT/i) || a.match(/KFJWA/i) || a.match(/KFJWI/i) || a.match(/KFSOWI/i) || a.match(/KFTHWA/i) || a.match(/KFTHWI/i) || a.match(/KFAPWA/i) || a.match(/KFAPWI/i) ? "kindle" : !1;
  }

  function Ja() {
    var a = navigator.userAgent;
    return Ha(a) ? Ia(a, 11) : !1;
  }

  function Ka(a) {
    try {
      var b = (x() && Ga() ? window.top.location.search : window.location.search).substring(1).match(new RegExp(a + "=([^&]*)"));
      if (b && 1 <= b.length) return b[1];
    } catch (c) {}
  }

  function La(a) {
    return a.replace(/(\-\w)/g, function (b) {
      return b[1].toUpperCase();
    });
  }

  function xa(a) {
    var b = "",
        c,
        d,
        e,
        f,
        k,
        g,
        l = 0;
    a = a.replace(/\r\n/g, "\n");
    d = "";

    for (e = 0; e < a.length; e++) {
      f = a.charCodeAt(e), 128 > f ? d += String.fromCharCode(f) : (127 < f && 2048 > f ? d += String.fromCharCode(f >> 6 | 192) : (d += String.fromCharCode(f >> 12 | 224), d += String.fromCharCode(f >> 6 & 63 | 128)), d += String.fromCharCode(f & 63 | 128));
    }

    for (a = d; l < a.length;) {
      c = a.charCodeAt(l++), d = a.charCodeAt(l++), e = a.charCodeAt(l++), f = c >> 2, c = (c & 3) << 4 | d >> 4, k = (d & 15) << 2 | e >> 6, g = e & 63, isNaN(d) ? g = k = 64 : isNaN(e) && (g = 64), b = b + "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(f) + "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(c) + "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(k) + "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(g);
    }

    return b;
  }

  function Ma(a, b, c) {
    "function" === typeof a.addEventListener ? a.addEventListener(b, c, void 0) : "function" === typeof a.attachEvent ? a.attachEvent("on" + b, c) : a["on" + b] = c;
  }

  function Na(a) {
    if (!a) return null;
    -1 < a.indexOf("://") && (a = a.split("://")[1]);
    return a.substring(a.indexOf("/") + 1);
  }

  function B(a) {
    if (!a) return null;
    -1 < a.indexOf("://") ? a = a.split("://")[1] : "/" === a.charAt(0) && (a = a.slice(1));
    return a;
  }

  function y(a) {
    var b;
    a = String(a);
    b = b || null;
    (a = document.querySelector('meta[property="og:' + a + '"]')) && a.content && (b = a.content);
    return b;
  }

  function C() {
    var a = document.getElementsByTagName("meta"),
        b = {};
    if (!a || 0 === a.length) return b;

    for (var c = {
      hostedIOS: null,
      hostedAndroid: null,
      applinksIOS: null,
      applinksAndroid: null,
      twitterIOS: null,
      twitterAndroid: null
    }, d = 0; d < a.length; d++) {
      if ((a[d].getAttribute("name") || a[d].getAttribute("property")) && a[d].getAttribute("content")) {
        var e = a[d].getAttribute("name"),
            f = a[d].getAttribute("property"),
            e = e || f,
            f = e.split(":");
        3 === f.length && "branch" === f[0] && "deeplink" === f[1] && ("$ios_deeplink_path" === f[2] ? c.hostedIOS = B(a[d].getAttribute("content")) : "$android_deeplink_path" === f[2] ? c.hostedAndroid = B(a[d].getAttribute("content")) : b[f[2]] = a[d].getAttribute("content"));
        "al:ios:url" === e && (c.applinksIOS = B(a[d].getAttribute("content")));
        "twitter:app:url:iphone" === e && (c.twitterIOS = B(a[d].getAttribute("content")));
        "al:android:url" === e && (c.applinksAndroid = B(a[d].getAttribute("content")));
        "twitter:app:url:googleplay" === e && (c.twitterAndroid = B(a[d].getAttribute("content")));
      }
    }

    c && "object" === typeof c && Object.keys(c).length && (c.hostedIOS ? b.$ios_deeplink_path = c.hostedIOS : c.applinksIOS ? b.$ios_deeplink_path = c.applinksIOS : c.twitterIOS && (b.$ios_deeplink_path = c.twitterIOS), c.hostedAndroid ? b.$android_deeplink_path = c.hostedAndroid : c.applinksAndroid ? b.$android_deeplink_path = c.applinksAndroid : c.twitterAndroid && (b.$android_deeplink_path = c.twitterAndroid), b.hasOwnProperty("$ios_deeplink_path") && b.hasOwnProperty("$android_deeplink_path") && b.$ios_deeplink_path === b.$android_deeplink_path && (b.$deeplink_path = b.$ios_deeplink_path));
    return b;
  }

  function Oa() {
    var a;

    try {
      navigator.languages && 0 < navigator.languages.length ? a = navigator.languages[0] : navigator.language && (a = navigator.language), a = a.substring(0, 2).toUpperCase();
    } catch (b) {
      a = null;
    }

    return a;
  }

  function Pa(a, b) {
    var c = [];
    b.forEach(function (b) {
      -1 === a.indexOf(b) && c.push(b);
    });
    return c;
  }

  var Qa = ["purchase"],
      Ra = {
    missingPurchaseEvent: "event name is either missing, of the wrong type or not valid. Please specify 'purchase' as the event name.",
    missingCommerceData: "commerce_data is either missing, of the wrong type or empty. Please ensure that commerce_data is constructed correctly.",
    invalidKeysForRoot: "Please remove the following keys from the root of commerce_data: ",
    invalidKeysForProducts: "Please remove the following keys from commerce_data.products: ",
    invalidProductListType: "commerce_data.products must be an array of objects",
    invalidProductType: "Each product in the products list must be an object"
  };

  function Sa(a) {
    var b = "sku name price quantity brand category variant".split(" "),
        c = Pa("common type transaction_id currency revenue revenue_in_usd exchange_rate shipping tax coupon affiliation persona products".split(" "), Object.keys(a));
    if (c.length) return Ra.invalidKeysForRoot + c.join(", ");
    var d = [],
        e;

    if (a.hasOwnProperty("products")) {
      if (!Array.isArray(a.products)) return Ra.invalidProductListType;
      a.products.forEach(function (a) {
        "object" !== typeof a && (e = Ra.invalidProductType);
        d = d.concat(Pa(b, Object.keys(a)));
      });
      if (e) return e;
      if (d.length) return Ra.invalidKeysForProducts + d.join(", ");
    }

    return null;
  }

  function Ta(a, b) {
    if (!a || "string" !== typeof a || -1 === Qa.indexOf(a.toLowerCase())) return Ra.missingPurchaseEvent;
    if (!b || "object" !== typeof b || !Object.keys(b).length) return Ra.missingCommerceData;
    var c = Sa(b);
    return c ? c : null;
  }

  function D(a) {
    return "string" !== typeof a ? null : a.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  function E(a, b, c) {
    if (null !== c && void 0 !== c) {
      if ("object" === typeof c && !Object.keys(c).length) return a;
      a[b] = c;
    }

    return a;
  }

  function Ua() {
    var a = {},
        b;
    b = {};
    b = E(b, "$og_title", y("title"));
    b = E(b, "$og_description", y("description"));
    b = E(b, "$og_image_url", y("image"));
    b = E(b, "$og_video", y("video"));
    b = (b = E(b, "$og_type", y("type"))) && 0 < Object.keys(b).length ? b : null;
    a = E(a, "og_data", b);
    a = E(a, "hosted_deeplink_data", C());
    b = document.getElementsByTagName("title");
    a = E(a, "title", 0 < b.length ? b[0].innerText : null);
    b = document.querySelector('meta[name="description"]');
    a = E(a, "description", b && b.content ? b.content : null);
    b = document.querySelector('link[rel="canonical"]');
    return (a = E(a, "canonical_url", b && b.href ? b.href : null)) && 0 < Object.keys(a).length ? a : {};
  }

  var Va = "ADD_TO_CART ADD_TO_WISHLIST VIEW_CART INITIATE_PURCHASE ADD_PAYMENT_INFO PURCHASE SPEND_CREDITS SEARCH VIEW_ITEM VIEW_ITEMS RATE SHARE COMPLETE_REGISTRATION COMPLETE_TUTORIAL ACHIEVE_LEVEL UNLOCK_ACHIEVEMENT LOGIN SUBSCRIBE".split(" "),
      Wa = "transaction_id revenue currency shipping tax coupon affiliation search_query description".split(" ");

  function Xa(a) {
    if (!a || !Object.keys(a).length) return null;

    for (var b = Pa(Wa, Object.keys(a)), c = {}, d = 0; d < b.length; d++) {
      var e = b[d];
      c[e] = a[e];
      delete a[e];
    }

    return {
      custom_data: Ya(c),
      event_data: a
    };
  }

  function F(a, b) {
    return !b || null === a && "object" === b ? !1 : "array" === b ? Array.isArray(a) : typeof a === b && !Array.isArray(a);
  }

  function Za(a) {
    var b = {},
        b = E(b, "http_origin", document.URL),
        b = E(b, "user_agent", navigator.userAgent),
        b = E(b, "language", Oa()),
        b = E(b, "screen_width", screen.width),
        b = E(b, "screen_height", screen.height),
        b = E(b, "http_referrer", document.referrer),
        b = E(b, "browser_fingerprint_id", a.B),
        b = E(b, "developer_identity", a.C),
        b = E(b, "sdk", "web");
    return b = E(b, "sdk_version", "2.52.3");
  }

  function x() {
    return window.self !== window.top;
  }

  function Ga() {
    var a = "true";

    try {
      window.top.location.search && (a = "true");
    } catch (b) {
      return !1;
    }

    return "true" === a;
  }

  function $a(a) {
    return a ? a : x() ? Ga() ? window.top.document.referrer : "" : document.referrer;
  }

  function Ya(a) {
    if (!F(a, "object") || !Object.keys(a).length) return {};

    for (var b in a) {
      a.hasOwnProperty(b) && (a[b] = F(a[b], "object") || F(a[b], "array") ? q(a[b]) : a[b].toString());
    }

    return a;
  }

  function ab(a, b) {
    var c = a ? z({}, a) : {};
    return b && 0 < Object.keys(b).length ? 0 < Object.keys(c).length ? z(c, b) : z({}, b) : c;
  }

  function G(a) {
    "" !== r && a.setAttribute("nonce", r);
  }

  ;

  function H(a, b) {
    return function (c, d, e) {
      if (v) return !1;
      if ("number" === typeof e || e) {
        if (0 === b) {
          if ("object" !== typeof e) return w("API request $1, parameter $2 is not $3", [c, d, "an object"]);
        } else if (3 === b) {
          if (!(e instanceof Array)) return w("API request $1, parameter $2 is not $3", [c, d, "an array"]);
        } else if (2 === b) {
          if ("number" !== typeof e) return w("API request $1, parameter $2 is not $3", [c, d, "a number"]);
        } else if (4 === b) {
          if ("boolean" !== typeof e) return w("API request $1, parameter $2 is not $3", [c, d, "a boolean"]);
        } else {
          if ("string" !== typeof e) return w("API request $1, parameter $2 is not $3", [c, d, "a string"]);
          if (1 !== b && !b.test(e)) return w("API request $1, parameter $2 is not $3", [c, d, "in the proper format"]);
        }
      } else if (a) return w("API request $1 missing parameter $2", [c, d]);
      return !1;
    };
  }

  var I = /^[0-9]{15,20}$/;

  function J(a) {
    return z(a, {
      browser_fingerprint_id: H(!0, I),
      identity_id: H(!0, I),
      sdk: H(!0, 1),
      session_id: H(!0, I)
    });
  }

  var bb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/open",
    method: "POST",
    a: {
      browser_fingerprint_id: H(!1, I),
      alternative_browser_fingerprint_id: H(!1, I),
      identity_id: H(!1, I),
      link_identifier: H(!1, 1),
      sdk: H(!1, 1),
      options: H(!1, 0),
      initial_referrer: H(!1, 1),
      tracking_disabled: H(!1, 4),
      current_url: H(!1, 1)
    }
  },
      cb = {
    destination: "https://app.link",
    endpoint: "/_r",
    method: "GET",
    Y: !0,
    a: {
      sdk: H(!0, 1),
      _t: H(!1, I),
      branch_key: H(!0, 1)
    }
  },
      db = {
    destination: "",
    endpoint: "",
    method: "GET",
    f: {
      link_url: H(!0, 1)
    },
    a: {
      click: H(!0, 1)
    }
  },
      eb = {
    destination: "https://bnc.lt",
    endpoint: "/c",
    method: "POST",
    f: {
      link_url: H(!0, 1)
    },
    a: {
      sdk: H(!1, 1),
      phone: H(!0, 1)
    }
  },
      fb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/referralcode",
    method: "POST",
    a: J({
      amount: H(!0, 2),
      bucket: H(!1, 1),
      calculation_type: H(!0, 2),
      creation_source: H(!0, 2),
      expiration: H(!1, 1),
      location: H(!0, 2),
      prefix: H(!1, 1),
      type: H(!0, 1)
    })
  },
      gb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/referralcode",
    method: "POST",
    f: {
      code: H(!0, 1)
    },
    a: J({})
  },
      hb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/applycode",
    method: "POST",
    f: {
      code: H(!0, 1)
    },
    a: J({})
  },
      ib = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/logout",
    method: "POST",
    a: J({
      session_id: H(!0, I)
    })
  },
      jb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/profile",
    method: "POST",
    a: J({
      identity_id: H(!0, I),
      identity: H(!0, 1)
    })
  },
      kb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/referrals",
    method: "GET",
    f: {
      identity_id: H(!0, I)
    },
    a: J({})
  },
      lb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/credithistory",
    method: "GET",
    a: J({
      begin_after_id: H(!1, I),
      bucket: H(!1, 1),
      direction: H(!1, 2),
      length: H(!1, 2),
      link_click_id: H(!1, I)
    })
  },
      mb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/credits",
    method: "GET",
    a: J({
      branch_key: H(!0, 1),
      identity: H(!0, 1)
    })
  },
      nb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/redeem",
    method: "POST",
    a: J({
      amount: H(!0, 2),
      bucket: H(!0, 1),
      identity_id: H(!0, I)
    })
  },
      ob = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/url",
    method: "POST",
    Aa: "obj",
    a: J({
      alias: H(!1, 1),
      campaign: H(!1, 1),
      channel: H(!1, 1),
      data: H(!1, 1),
      feature: H(!1, 1),
      identity_id: H(!0, I),
      stage: H(!1, 1),
      tags: H(!1, 3),
      type: H(!1, 2),
      source: H(!1, 1),
      instrumentation: H(!1, 1)
    })
  },
      pb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/deepview",
    Y: !0,
    method: "POST",
    a: J({
      campaign: H(!1, 1),
      _t: H(!1, I),
      channel: H(!1, 1),
      data: H(!0, 1),
      feature: H(!1, 1),
      link_click_id: H(!1, 1),
      open_app: H(!1, 4),
      append_deeplink_path: H(!1, 4),
      stage: H(!1, 1),
      tags: H(!1, 3),
      deepview_type: H(!0, 1),
      source: H(!0, 1)
    })
  },
      qb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/has-app",
    method: "GET",
    a: {
      browser_fingerprint_id: H(!0, I),
      instrumentation: H(!1, 1)
    }
  },
      rb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/event",
    method: "POST",
    a: J({
      event: H(!0, 1),
      metadata: H(!0, 0),
      initial_referrer: H(!1, 1),
      tracking_disabled: H(!1, 4)
    })
  },
      sb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/event",
    method: "POST",
    a: J({
      event: H(!0, 1),
      metadata: H(!1, 0),
      initial_referrer: H(!1, 1),
      commerce_data: H(!0, 0)
    })
  },
      tb = {
    destination: "https://api2.branch.io",
    endpoint: "/v2/event/standard",
    method: "POST",
    a: {
      name: H(!0, 1),
      user_data: H(!0, 1),
      custom_data: H(!1, 1),
      event_data: H(!1, 1),
      content_items: H(!1, 1),
      customer_event_alias: H(!1, 1)
    }
  },
      ub = {
    destination: "https://api2.branch.io",
    endpoint: "/v2/event/custom",
    method: "POST",
    a: {
      name: H(!0, 1),
      user_data: H(!0, 1),
      custom_data: H(!1, 1)
    }
  },
      vb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/pageview",
    method: "POST",
    a: J({
      event: H(!0, 1),
      metadata: H(!1, 0),
      initial_referrer: H(!1, 1),
      tracking_disabled: H(!1, 4),
      branch_view_id: H(!1, 1),
      no_journeys: H(!1, 4),
      user_language: H(!1, 1),
      open_app: H(!1, 4),
      has_app_websdk: H(!1, 4),
      source: H(!1, 1),
      feature: H(!1, 1),
      is_iframe: H(!1, 4),
      data: H(!1, 0),
      callback_string: H(!1, 1),
      journey_displayed: H(!1, 4),
      audience_rule_id: H(!1, 1),
      journey_dismissals: H(!1, 0)
    })
  },
      wb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/dismiss",
    method: "POST",
    a: J({
      event: H(!0, 1),
      metadata: H(!1, 0),
      initial_referrer: H(!1, 1),
      tracking_disabled: H(!1, 4),
      branch_view_id: H(!1, 1),
      no_journeys: H(!1, 4),
      user_language: H(!1, 1),
      open_app: H(!1, 4),
      has_app_websdk: H(!1, 4),
      source: H(!1, 1),
      feature: H(!1, 1),
      is_iframe: H(!1, 4),
      data: H(!1, 0),
      callback_string: H(!1, 1),
      journey_displayed: H(!1, 4),
      audience_rule_id: H(!1, 1),
      journey_dismissals: H(!1, 0)
    })
  },
      xb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/cpid",
    method: "POST",
    a: {
      user_data: H(!0, 1)
    }
  },
      yb = {
    destination: "https://api2.branch.io",
    endpoint: "/v1/cpid/latd",
    method: "POST",
    a: {
      user_data: H(!0, 1)
    }
  };

  function zb(a) {
    for (var b = 0; b < a.length; b++) {
      var c = this[a[b]],
          c = "function" === typeof c ? c() : c;
      if (c.isEnabled()) return c.u = {}, c;
    }
  }

  function K(a) {
    return "branch_session" === a || "branch_session_first" === a ? a : "BRANCH_WEBSDK_KEY" + a;
  }

  function Ab(a) {
    return "true" === a ? !0 : "false" === a ? !1 : a;
  }

  function Bb(a) {
    return "branch_session" === a || "branch_session_first" === a || 0 === a.indexOf("BRANCH_WEBSDK_KEY");
  }

  function Cb(a) {
    a = a.trim();
    var b = a.indexOf("=");
    return {
      name: a.substring(0, b),
      value: Ab(a.substring(b + 1, a.length))
    };
  }

  function Db(a) {
    var b;

    try {
      b = a && localStorage ? localStorage : sessionStorage;
    } catch (c) {
      return {
        isEnabled: function isEnabled() {
          return !1;
        }
      };
    }

    return {
      getAll: function getAll() {
        if ("undefined" === typeof b) return null;
        var a = null,
            d;

        for (d in b) {
          d.indexOf("BRANCH_WEBSDK_KEY") || (null === a && (a = {}), a[d.replace("BRANCH_WEBSDK_KEY", "")] = Ab(b.getItem(d)));
        }

        return a;
      },
      get: function get(a, d) {
        return Ab(d && localStorage ? localStorage.getItem(K(a)) : b.getItem(K(a)));
      },
      set: function set(a, d, e) {
        e && localStorage ? localStorage.setItem(K(a), d) : b.setItem(K(a), d);
      },
      remove: function remove(a, d) {
        d && localStorage ? localStorage.removeItem(K(a)) : b.removeItem(K(a));
      },
      clear: function clear() {
        Object.keys(b).forEach(function (a) {
          a.indexOf("BRANCH_WEBSDK_KEY") || b.removeItem(a);
        });
      },
      isEnabled: function isEnabled() {
        try {
          return b.setItem("test", ""), b.removeItem("test"), !0;
        } catch (c) {
          return !1;
        }
      }
    };
  }

  zb.prototype.local = function () {
    return Db(!0);
  };

  zb.prototype.session = function () {
    return Db(!1);
  };

  function Eb() {
    function a(b, a) {
      a && (b = K(b));
      document.cookie = b + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
    }

    return {
      getAll: function getAll() {
        for (var b = {}, a = document.cookie.split(";"), d = 0; d < a.length; d++) {
          var e = Cb(a[d]);
          e && e.hasOwnProperty("name") && e.hasOwnProperty("value") && Bb(e.name) && (b[e.name.replace("BRANCH_WEBSDK_KEY", "")] = e.value);
        }

        return b;
      },
      get: function get(a) {
        a = K(a);

        for (var b = document.cookie.split(";"), d = 0; d < b.length; d++) {
          var e = Cb(b[d]);
          if (e && e.hasOwnProperty("name") && e.hasOwnProperty("value") && e.name === a) return e.value;
        }

        return null;
      },
      set: function set(a, c) {
        document.cookie = K(a) + "=" + c + "; path=/";
      },
      remove: function remove(b) {
        a(b, !0);
      },
      clear: function clear() {
        for (var b = document.cookie.split(";"), c = 0; c < b.length; c++) {
          var d = Cb(b[c]);
          d && d.hasOwnProperty("name") && Bb(d.name) && a(d.name, !1);
        }
      },
      isEnabled: function isEnabled() {
        return navigator.cookieEnabled;
      }
    };
  }

  zb.prototype.cookie = function () {
    return Eb();
  };

  zb.prototype.pojo = {
    getAll: function getAll() {
      return this.u;
    },
    get: function get(a) {
      return this.u[a] || null;
    },
    set: function set(a, b) {
      this.u[a] = b;
    },
    remove: function remove(a) {
      delete this.u[a];
    },
    clear: function clear() {
      this.u = {};
    },
    isEnabled: function isEnabled() {
      return !0;
    }
  };

  function L(a, b) {
    try {
      return n(a.get(b ? "branch_session_first" : "branch_session", b)) || null;
    } catch (c) {
      return null;
    }
  }

  function za(a, b, c) {
    a.set("branch_session", h(b));
    c && a.set("branch_session_first", h(b), !0);
  }

  function Fb(a, b) {
    if (b) {
      var c = L(a) || {},
          c = z(c, b);
      a.set("branch_session", h(c));
    }
  }

  ;

  function Gb() {}

  Gb.prototype.g = 0;

  function Hb(a, b, c) {
    if ("undefined" === typeof b) return "";
    var d = [];

    if (b instanceof Array) {
      for (a = 0; a < b.length; a++) {
        d.push(encodeURIComponent(c) + "=" + encodeURIComponent(b[a]));
      }

      return d.join("&");
    }

    for (var e in b) {
      b.hasOwnProperty(e) && (b[e] instanceof Array || "object" === typeof b[e] ? d.push(Hb(a, b[e], c ? c + "." + e : e)) : d.push(encodeURIComponent(c ? c + "." + e : e) + "=" + encodeURIComponent(b[e])));
    }

    return d.join("&");
  }

  function Ib(a, b, c) {
    function d(a, c) {
      "undefined" === typeof c && (c = {});
      if (a.branch_key && l.test(a.branch_key)) return c.branch_key = a.branch_key, c;
      if (a.app_id && g.test(a.app_id)) return c.app_id = a.app_id, c;
      if (a.instrumentation) c.instrumentation = a.instrumentation;else throw Error(w("API request $1 missing parameter $2", [b.endpoint, "branch_key or app_id"]));
    }

    var e,
        f,
        k = b.destination + b.endpoint,
        g = /^[0-9]{15,20}$/,
        l = /key_(live|test)_[A-Za-z0-9]{32}/;
    if ("/v1/has-app" === b.endpoint) try {
      b.f = d(c, b.f);
    } catch (p) {
      return {
        error: p.message
      };
    }
    if ("undefined" !== typeof b.f) for (e in b.f) {
      if (b.f.hasOwnProperty(e)) {
        if (f = "function" === typeof b.f[e] ? b.f[e](b.endpoint, e, c[e]) : f) return {
          error: f
        };
        k += "/" + c[e];
      }
    }
    var m = {};
    if ("undefined" !== typeof b.a && "/v1/pageview" !== b.endpoint && "/v1/dismiss" !== b.endpoint) for (e in b.a) {
      if (b.a.hasOwnProperty(e)) {
        if (f = b.a[e](b.endpoint, e, c[e])) return {
          error: f
        };
        f = c[e];
        "undefined" !== typeof f && "" !== f && null !== f && (m[e] = f);
      }
    } else "/v1/pageview" !== b.endpoint && "/v1/dismiss" !== b.endpoint || z(m, c);
    if ("POST" === b.method || "/v1/credithistory" === b.endpoint) try {
      c = d(c, m);
    } catch (p) {
      return {
        error: p.message
      };
    }
    "/v1/event" === b.endpoint && (m.metadata = q(m.metadata || {}), m.hasOwnProperty("commerce_data") && (m.commerce_data = q(m.commerce_data || {})));
    ("/v1/pageview" === b.endpoint || "/v1/dismiss" === b.endpoint) && m.metadata && (m.metadata = q(m.metadata || {}));
    "/v1/open" === b.endpoint && (m.options = q(m.options || {}));
    return {
      data: Hb(a, m, ""),
      url: k.replace(/^\//, "")
    };
  }

  function Jb(a, b, c) {
    var d = document.createElement("script");
    d.type = "text/javascript";
    d.async = !0;
    d.src = a;
    G(d);
    a = document.getElementsByTagName("head");
    !a || 1 > a.length ? "function" === typeof b && b() : (a[0].appendChild(d), "function" === typeof b && Ma(d, "error", b), "function" === typeof c && Ma(d, "load", c));
  }

  function Kb(a, b, c, d, e) {
    var f = Date.now(),
        k = ra;
    !a.g && Ja() && a.g++;
    var g = "branch_callback__" + a.g++;
    a = 0 <= b.indexOf("branch.io") ? "&data=" : "&post_data=";
    c = "POST" === d ? encodeURIComponent(xa(h(c))) : "";
    var l = window.setTimeout(function () {
      window[g] = function () {};

      E(u, k, sa(f));
      e(Error("Request timed out"), null, 504);
    }, pa);

    window[g] = function (a) {
      window.clearTimeout(l);
      e(null, a);
    };

    Jb(b + (0 > b.indexOf("?") ? "?" : "") + (c ? a + c : "") + (0 <= b.indexOf("/c/") ? "&click=1" : "") + "&callback=" + g, function () {
      e(Error("Request blocked by client, probably adblock"), null);
    }, function () {
      E(u, k, sa(f));

      try {
        "function" === typeof this.remove ? this.remove() : this.parentNode.removeChild(this);
      } catch (m) {}

      delete window[g];
    });
  }

  function Lb(a, b, c, d, e, f) {
    var k = Date.now(),
        g = ra,
        l = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");

    l.ontimeout = function () {
      E(u, g, sa(k));
      f(Error("Request timed out"), null, 504);
    };

    l.onerror = function (a) {
      f(Error(a.error || "Error in API: " + l.status), null, l.status);
    };

    l.onreadystatechange = function () {
      var a;
      if (4 === l.readyState) if (E(u, g, sa(k)), 200 === l.status) {
        try {
          a = n(l.responseText);
        } catch (p) {
          a = {};
        }

        f(null, a, l.status);
      } else if (402 === l.status) f(Error("Not enough credits to redeem."), null, l.status);else if ("4" === l.status.toString().substring(0, 1) || "5" === l.status.toString().substring(0, 1)) l.responseURL && l.responseURL.includes("v2/event") ? f(l.responseText, null, l.status) : f(Error("Error in API: " + l.status), null, l.status);
    };

    try {
      l.open(d, b, !0), l.timeout = pa, l.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), l.send(c);
    } catch (m) {
      e.set("use_jsonp", !0), Kb(a, b, c, d, f);
    }
  }

  function Mb(a, b, c, d, e) {
    function f() {
      d.get("use_jsonp") || b.Y ? Kb(a, m, c, b.method, k) : Lb(a, m, p, b.method, d, k);
    }

    function k(a, b, c) {
      a && 0 < t && "5" === (c || "").toString().substring(0, 1) ? (t--, window.setTimeout(function () {
        f();
      }, oa)) : e(a, b);
    }

    ra = "/v1/pageview" === b.endpoint && c && c.journey_displayed ? b.endpoint + "-1-brtt" : b.endpoint + "-brtt";
    ("/v1/url" === b.endpoint || "/v1/has-app" === b.endpoint) && 1 < Object.keys(u).length && (delete u["-brtt"], c.instrumentation = q(z({}, u)), u = {});
    if (v) for (var g = ["browser_fingerprint_id", "alternative_browser_fingerprint_id", "identity_id", "session_id"], l = 0; l < g.length; l++) {
      c.hasOwnProperty(g[l]) && delete c[g[l]];
    }
    g = Ib(a, b, c);
    if (g.error) return e(Error(q({
      message: g.error,
      endpoint: b.endpoint,
      data: c
    })));
    var m,
        p = "";
    "GET" === b.method ? m = g.url + "?" + g.data : (m = g.url, p = g.data);
    var t = na;
    if (v && va(m, c)) return ua ? k(Error("Requested operation cannot be completed since tracking is disabled"), null, 300) : k(null, {}, 200);
    f();
  }

  ;

  function M(a) {
    a && a.parentNode.removeChild(a);
  }

  function Nb(a, b) {
    a && !a.className.match(new RegExp("(\\s|^)" + b + "(\\s|$)")) && (a.className += " " + b);
  }

  function Ob(a) {
    var b = document.body;
    b && b.className.match(new RegExp("(\\s|^)" + a + "(\\s|$)")) && (b.className = b.className.replace(new RegExp("(\\s|^)" + a + "(\\s|$)"), " "));
  }

  function Pb(a) {
    var b = new Date();
    return b.setDate(b.getDate() + a);
  }

  function Qb(a) {
    return document.body.currentStyle ? document.body.currentStyle[La(a)] : window.getComputedStyle(document.body).getPropertyValue(a);
  }

  function Rb(a) {
    function b(a) {
      function c() {
        return Math.max(document.documentElement.clientHeight, window.innerHeight || 0) / 100;
      }

      function e() {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) / 100;
      }

      if (!a) return 0;
      var f = a.replace(/[0-9,\.]/g, "");
      a = a.match(/\d+/g);
      var k = parseInt(0 < a.length ? a[0] : "0", 10);
      return parseInt({
        px: function px(a) {
          return a;
        },
        em: function em(a) {
          return document.body.currentStyle ? a * b(document.body.currentStyle.fontSize) : a * parseFloat(window.getComputedStyle(document.body).fontSize);
        },
        rem: function rem(a) {
          return document.documentElement.currentStyle ? a * b(document.documentElement.currentStyle.fontSize) : a * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
        },
        vw: function vw(a) {
          return a * e();
        },
        vh: function vh(a) {
          return a * c();
        },
        vmin: function vmin(a) {
          return a * Math.min(c(), e());
        },
        vmax: function vmax(a) {
          return a * Math.max(c(), e());
        },
        "%": function _() {
          return document.body.clientWidth / 100 * k;
        }
      }[f](k), 10);
    }

    return (b("76px") + b(a)).toString() + "px";
  }

  function Sb(a, b) {
    var c = a.get("hideBanner", !0);
    if (b.pa && navigator && Number(navigator.doNotTrack)) return !1;

    try {
      "string" === typeof c && (c = n(c));
    } catch (e) {
      c = !1;
    }

    var c = "number" === typeof c ? new Date() >= new Date(c) : !c,
        d = b.K;
    "number" === typeof d && (d = !1);
    return !document.getElementById("branch-banner") && !document.getElementById("branch-banner-iframe") && (c || d) && (b.ra && !A() || b.O && "android" === A() || b.sa && "ipad" === A() || b.T && "ios" === A() || b.P && "blackberry" === A() || b.S && "windows_phone" === A() || b.R && "kindle" === A());
  }

  ;

  function Tb(a, b) {
    return "#branch-banner-iframe { position: " + ("top" !== b || a ? "fixed" : "absolute") + "; }\n";
  }

  function Ub(a, b) {
    var c = ".branch-banner-is-active { -webkit-transition: all 0.375s ease; transition: all 00.375s ease; }\n#branch-banner { width:100%; z-index: 99999; font-family: Helvetica Neue, Sans-serif; -webkit-font-smoothing: antialiased; -webkit-user-select: none; -moz-user-select: none; user-select: none; -webkit-transition: all 0.25s ease; transition: all 00.25s ease; }\n#branch-banner .button{ border: 1px solid " + (a.buttonBorderColor || ("dark" === a.theme ? "transparent" : "#ccc")) + "; background: " + (a.buttonBackgroundColor || "#fff") + "; color: " + (a.buttonFontColor || "#000") + "; cursor: pointer; margin-top: 0px; font-size: 14px; display: inline-block; margin-left: 5px; font-weight: 400; text-decoration: none;  border-radius: 4px; padding: 6px 12px; transition: all .2s ease;}\n#branch-banner .button:hover {  border: 1px solid " + (a.buttonBorderColorHover || ("dark" === a.theme ? "transparent" : "#BABABA")) + "; background: " + (a.buttonBackgroundColorHover || "#E0E0E0") + "; color: " + (a.buttonFontColorHover || "#000") + ";}\n#branch-banner .button:focus { outline: none; }\n#branch-banner * { margin-right: 4px; position: relative; line-height: 1.2em; }\n#branch-banner-close { font-weight: 400; cursor: pointer; float: left; z-index: 2;padding: 0 5px 0 5px; margin-right: 0; }\n#branch-banner .content { width:100%; overflow: hidden; height: 76px; background: rgba(255, 255, 255, 0.95); color: #333; " + ("top" === a.position ? "border-bottom" : "border-top") + ': 1px solid #ddd; }\n#branch-banner-close { color: #000; font-size: 24px; top: 14px; opacity: .5; transition: opacity .3s ease; }\n#branch-banner-close:hover { opacity: 1; }\n#branch-banner .title { font-size: 18px; font-weight:bold; color: #555; }\n#branch-banner .description { font-size: 12px; font-weight: normal; color: #777; max-height: 30px; overflow: hidden; }\n#branch-banner .icon { float: left; padding-bottom: 40px; margin-right: 10px; margin-left: 5px; }\n#branch-banner .icon img { width: 63px; height: 63px; margin-right: 0; }\n#branch-banner .reviews { font-size:13px; margin: 1px 0 3px 0; color: #777; }\n#branch-banner .reviews .star { display:inline-block; position: relative; margin-right:0; }\n#branch-banner .reviews .star span { display: inline-block; margin-right: 0; color: #555; position: absolute; top: 0; left: 0; }\n#branch-banner .reviews .review-count { font-size:10px; }\n#branch-banner .reviews .star .half { width: 50%; overflow: hidden; display: block; }\n#branch-banner .content .left { padding: 6px 5px 6px 5px; }\n#branch-banner .vertically-align-middle { top: 50%; transform: translateY(-50%); -webkit-transform: translateY(-50%); -ms-transform: translateY(-50%); }\n#branch-banner .details > * { display: block; }\n#branch-banner .content .left { height: 63px; }\n#branch-banner .content .right { float: right; height: 63px; margin-bottom: 50px; padding-top: 22px; z-index: 1; }\n#branch-banner .right > div { float: left; }\n#branch-banner-action { top: 17px; }\n#branch-banner .content:after { content: ""; position: absolute; left: 0; right: 0; top: 100%; height: 1px; background: rgba(0, 0, 0, 0.2); }\n#branch-banner .theme-dark.content { background: rgba(51, 51, 51, 0.95); }\n#branch-banner .theme-dark #branch-banner-close{ color: #fff; text-shadow: 0 1px 1px rgba(0, 0, 0, .15); }\n#branch-banner .theme-dark .details { text-shadow: 0 1px 1px rgba(0, 0, 0, .15); }\n#branch-banner .theme-dark .title { color: #fff; }\n#branch-banner .theme-dark .description { color: #fff; }\n#branch-banner .theme-dark .reviews { color: #888; }\n#branch-banner .theme-dark .reviews .star span{ color: #fff; }\n#branch-banner .theme-dark .reviews .review-count{ color: #fff; }\n',
        d = A();
    "ios" !== d && "ipad" !== d || !a.T ? "android" === d && a.O ? c += "#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n#branch-banner #branch-banner-close,#branch-banner .theme-dark #branch-banner-close { height:17px; width: 17px; text-align: center; font-size: 15px; top: 24px;  border-radius:14px; border:0; line-height:14px; color:#b1b1b3; background:#efefef; padding: 0; opacity: 1; }\n#branch-banner .button { top: 0; text-decoration:none; border-bottom: 3px solid #A4C639; padding: 0 10px; height: 24px; line-height: 24px; text-align: center; color: #fff; margin-top: 2px;  font-weight: bold; background-color: #A4C639; border-radius: 5px; }\n#branch-banner .button:hover { border-bottom:3px solid #8c9c29; background-color: #c1d739; }\n" : "blackberry" === d && a.P ? c += "#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n" : "windows_phone" === d && a.S ? c += "#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n" : "kindle" === d && a.R ? c += "#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n" : (c += "#branch-banner { position: fixed; min-width: 600px; }\n#branch-sms-block * { vertical-align: bottom; font-size: 15px; }\n#branch-sms-block { display: inline-block; }\n#branch-banner input{ border: 1px solid #ccc;  font-weight: 400;  border-radius: 4px; height: 30px; padding: 5px 7px 4px; width: 145px; font-size: 14px;}\n#branch-banner input:focus { outline: none; }\n#branch-banner input.error { color: rgb(194, 0, 0); border-color: rgb(194, 0, 0); }\n#branch-banner .branch-icon-wrapper { width:25px; height: 25px; vertical-align: middle; display: inline-block; margin-top: -18px; }\n@keyframes branch-spinner { 0% { transform: rotate(0deg); -webkit-transform: rotate(0deg); -ms-transform: rotate(0deg); } 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); } }\n@-webkit-keyframes branch-spinner { 0% { transform: rotate(0deg); -webkit-transform: rotate(0deg); -ms-transform: rotate(0deg); } 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); } }\n#branch-spinner { -webkit-animation: branch-spinner 1s ease-in-out infinite; animation: branch-spinner 1s ease-in-out infinite; transition: all 0.7s ease-in-out; border:2px solid #ddd; border-bottom-color:#428bca; width:80%; height:80%; border-radius:50%; -webkit-font-smoothing: antialiased !important; }\n#branch-banner .theme-dark input { border-color: transparent; }\n", c = window.ActiveXObject ? c + "#branch-banner .checkmark { color: #428bca; font-size: 22px; }\n" : c + "#branch-banner .checkmark { stroke: #428bca; stroke-dashoffset: 745.74853515625; stroke-dasharray: 745.74853515625; -webkit-animation: dash 2s ease-out forwards; animation: dash 2s ease-out forwards; }\n@-webkit-keyframes dash { 0% { stroke-dashoffset: 745.748535 15625; } 100% { stroke-dashoffset: 0; } }\n@keyframes dash { 0% { stroke-dashoffset: 745.74853515625; } 100% { stroke-dashoffset: 0; } }\n") : c += "#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n";
    c += a.ea;
    a.D && (c += "body { margin: 0; }\n", d = document.createElement("style"), d.type = "text/css", d.id = "branch-iframe-css", G(d), d.innerHTML = "body { -webkit-transition: all 0.375s ease; transition: all 00.375s ease; }\n#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width:100%; left: 0; right: 0; border: 0; height: 76px; z-index: 99999; -webkit-transition: all 0.25s ease; transition: all 00.25s ease; }\n" + (A() ? Tb(a.la, a.position) : Tb(a.fa, a.position)), (document.head || document.getElementsByTagName("head")[0]).appendChild(d));
    d = document.createElement("style");
    d.type = "text/css";
    d.id = "branch-css";
    d.innerHTML = c;
    G(d);
    c = a.D ? b.contentWindow.document : document;
    (c = c.head || c.getElementsByTagName("head")[0]) && "function" === typeof c.appendChild && c.appendChild(d);
    "top" === a.position ? b.style.top = "-76px" : "bottom" === a.position && (b.style.bottom = "-76px");
  }

  ;

  function Vb(a, b) {
    var c;

    if (a.w || a.L) {
      if (a.w) {
        c = "";

        for (var d = 0; 5 > d; d++) {
          c += "<span class=\"star\"><svg class=\"star\" fill=\"#555555\" height=\"12\" viewBox=\"3 2 20 19\" width=\"12\"><path d=\"M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z\"/><path d=\"M0 0h24v24H0z\" fill=\"none\"/><foreignObject display=\"none\"><span class=\"star\">\u2606</span></foreignObject></svg>", a.w > d && (c += d + 1 > a.w && a.w % 1 ? "<span class=\"half\"><svg fill=\"#555555\" height=\"12\" viewBox=\"3 2 20 19\" width=\"12\"><defs><path d=\"M0 0h24v24H0V0z\" id=\"a\"/></defs><clipPath id=\"b\"><use overflow=\"visible\" xlink:href=\"#a\"/></clipPath><path clip-path=\"url(#b)\" d=\"M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z\"/></svg><foreignObject display=\"none\"><span class=\"half\">\u2605</span></foreignObject></span>" : "<span class=\"full\"><svg fill=\"#555555\" height=\"12\" viewBox=\"3 2 20 19\" width=\"12\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z\"/><path d=\"M0 0h24v24H0z\" fill=\"none\"/><foreignObject display=\"none\"><span class=\"full\">\u2605</span></foreignObject></svg> </span>"), c += "</span>";
        }

        c = '<span class="stars">' + c + "</span>";
      } else c = "";

      c = '<div class="reviews">' + c + (a.L ? '<span class="review-count">' + a.L + "</span>" : "") + "</div>";
    } else c = "";

    return '<div class="content' + (a.theme ? " theme-" + a.theme : "") + '"><div class="right">' + b + '</div><div class="left">' + (a.ha ? "" : '<div id="branch-banner-close" class="branch-animation" aria-label="Close">&times;</div>') + '<div class="icon"><img src="' + a.icon + '" alt="Application icon"></div><div class="details vertically-align-middle"><div class="title">' + a.title + "</div>" + c + '<div class="description">' + a.description + "</div></div></div></div>";
  }

  function Wb(a, b) {
    var c = '<div id="branch-sms-form-container">' + (A() ? '<a id="branch-mobile-action" class="button" href="#" target="_parent">' + ((L(b) || {}).has_app ? a.ma : a.ia) + "</a>" : '<div class="branch-icon-wrapper" id="branch-loader-wrapper" style="opacity: 0;"><div id="branch-spinner"></div></div><div id="branch-sms-block"><form id="sms-form"><input type="phone" aria-label="Enter phone number" class="branch-animation" name="branch-sms-phone" id="branch-sms-phone" placeholder="' + a.oa + '"><button type="submit" id="branch-sms-send" class="branch-animation button">' + a.qa + "</button></form></div>") + "</div>";

    if (a.D) {
      var d = document.createElement("iframe");
      d.src = "about:blank";
      d.style.overflow = "hidden";
      d.scrolling = "no";
      d.id = "branch-banner-iframe";
      d.className = "branch-animation";
      G(d);
      document.body.appendChild(d);
      var e = A(),
          c = '<html><head></head><body class="' + ("ios" === e || "ipad" === e ? "branch-banner-ios" : "android" === e ? "branch-banner-android" : "branch-banner-desktop") + '"><div id="branch-banner" class="branch-animation">' + Vb(a, c) + "</body></html>";
      d.contentWindow.document.open();
      d.contentWindow.document.write(c);
      d.contentWindow.document.close();
    } else d = document.createElement("div"), d.id = "branch-banner", d.className = "branch-animation", d.innerHTML = Vb(a, c), document.body.appendChild(d);

    return c = d;
  }

  ;

  function Xb(a, b, c, d) {
    function e() {
      k();
      l.style.background = "#FFD4D4";
      g.className = "error";
      setTimeout(function () {
        l.style.background = "#FFFFFF";
        g.className = "";
      }, 2E3);
    }

    function f() {
      t = a.createElement("div");
      t.className = "branch-icon-wrapper";
      t.id = "branch-checkmark";
      t.style = "opacity: 0;";
      t.innerHTML = window.ActiveXObject ? '<span class="checkmark">&#x2713;</span>' : '<svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 98.5 98.5" enable-background="new 0 0 98.5 98.5" xml:space="preserve"><path class="checkmark" fill="none" stroke-width="8" stroke-miterlimit="10" d="M81.7,17.8C73.5,9.3,62,4,49.2,4C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"/></svg>';
      p.appendChild(t);
      l.style.opacity = "0";
      g.style.opacity = "0";
      m.style.opacity = "0";
      setTimeout(function () {
        t.style.opacity = "1";
      }, 20);
      g.value = "";
    }

    function k() {
      l.removeAttribute("disabled");
      g.removeAttribute("disabled");
      l.style.opacity = "1";
      g.style.opacity = "1";
      m.style.opacity = "0";
    }

    var g = a.getElementById("branch-sms-phone"),
        l = a.getElementById("branch-sms-send"),
        m = a.getElementById("branch-loader-wrapper"),
        p = a.getElementById("branch-sms-form-container"),
        t;

    if (g) {
      var Q = g.value;
      /^\d{7,}$/.test(Q.replace(/[\s()+\-\.]|ext/gi, "")) ? (N(b, "willSendBannerSMS"), l.setAttribute("disabled", ""), g.setAttribute("disabled", ""), l.style.opacity = ".4", g.style.opacity = ".4", m.style.opacity = "1", g.className = "", b.sendSMS(Q, d, c, function (a) {
        a ? (N(b, "sendBannerSMSError"), e()) : (N(b, "didSendBannerSMS"), f(), setTimeout(function () {
          p.removeChild(t);
          k();
        }, 3E3));
      })) : e();
    }
  }

  function Yb(a, b, c, d) {
    function e(a, c) {
      "function" === typeof a && (c = a, a = {});
      a = a || {};
      "top" === b.position ? k.style.top = "-76px" : "bottom" === b.position && (k.style.bottom = "-76px");
      "number" === typeof b.K ? d.set("hideBanner", Pb(b.K), !0) : d.set("hideBanner", !0, !0);
      a.X ? ("top" === b.position ? document.body.style.marginTop = m : "bottom" === b.position && (document.body.style.marginBottom = t), Ob("branch-banner-is-active"), M(k), M(document.getElementById("branch-css")), c()) : (setTimeout(function () {
        M(k);
        M(document.getElementById("branch-css"));
        c();
      }, 270), setTimeout(function () {
        "top" === b.position ? document.body.style.marginTop = m : "bottom" === b.position && (document.body.style.marginBottom = t);
        Ob("branch-banner-is-active");
      }, 20));
    }

    function f() {
      "top" === b.position ? k.style.top = "0" : "bottom" === b.position && (k.style.bottom = "0");
      N(a, "didShowBanner");
    }

    if (!Sb(d, b)) return N(a, "willNotShowBanner"), null;
    N(a, "willShowBanner");
    var k = Wb(b, d);
    Ub(b, k);
    c.channel = c.channel || "app banner";
    var g = b.D ? k.contentWindow.document : document;

    if (A()) {
      b.open_app = b.na;
      b.append_deeplink_path = b.ba;
      b.make_new_link = b.ka;
      b.deepview_type = "banner";
      a.deepview(c, b);
      var l = g.getElementById("branch-mobile-action");
      l && (l.onclick = function (b) {
        b.preventDefault();
        a.deepviewCta();
      });
    } else g.getElementById("sms-form") ? g.getElementById("sms-form").addEventListener("submit", function (d) {
      d.preventDefault();
      Xb(g, a, b, c);
    }) : k.onload = function () {
      g = k.contentWindow.document;
      g.getElementById("sms-form") && g.getElementById("sms-form").addEventListener("submit", function (d) {
        d.preventDefault();
        Xb(g, a, b, c);
      });
    };

    var l = Qb("margin-top"),
        m = document.body.style.marginTop,
        p = Qb("margin-bottom"),
        t = document.body.style.marginBottom,
        Q = g.getElementById("branch-banner-close");
    Q && (Q.onclick = function (b) {
      b.preventDefault();
      N(a, "willCloseBanner");
      e({}, function () {
        N(a, "didCloseBanner");
      });
    });
    Nb(document.body, "branch-banner-is-active");
    "top" === b.position ? document.body.style.marginTop = Rb(l) : "bottom" === b.position && (document.body.style.marginBottom = Rb(p));
    b.X ? f() : setTimeout(f, 20);
    return e;
  }

  ;
  var Zb,
      $b = 1,
      O = "top",
      ac = "absolute",
      P = "76px",
      bc = !1,
      cc = !1,
      R = [],
      dc = !1,
      ec = window.innerHeight,
      fc = window.innerWidth;
  window.innerHeight < window.innerWidth && (ec = window.innerWidth, fc = window.innerHeight);
  var gc = 0,
      hc = 0,
      ic = /<script type="application\/json">((.|\s)*?)<\/script>/,
      jc = /<script type="text\/javascript">((.|\s)*?)<\/script>/,
      kc = /<style type="text\/css" id="branch-css">((.|\s)*?)<\/style>/,
      lc = /<style type="text\/css" id="branch-iframe-css">((.|\s)*?)<\/style>/,
      mc = /#branch-banner-spacer {((.|\s)*?)}/,
      nc = /margin-bottom: (.*?);/,
      S = null,
      oc = null,
      pc = !1,
      qc = !1,
      rc = !1,
      sc = !1,
      tc = !1,
      uc = "",
      vc = [],
      T = null;

  function wc(a) {
    if (a = a.match(ic)) return n(a[1]);
  }

  function xc(a) {
    var b = document.createElement("style");
    b.type = "text/css";
    b.id = "branch-iframe-css";
    gc = Qb("margin-top");
    var c = +gc.slice(0, -2);
    hc = Qb("margin-bottom");
    var d = +hc.slice(0, -2),
        e = +P.slice(0, -2);
    a || ("top" === O ? document.body.style.marginTop = (+e + c).toString() + "px" : "bottom" === O && (document.body.style.marginBottom = (+e + d).toString() + "px"));
    0 < R.length && R.forEach(function (a) {
      var b,
          c = window.getComputedStyle(a);
      c && (b = bc && "fixed" === c.getPropertyValue("position"));
      b || (a.style.marginTop = P);
    });
    "top" === uc && uc !== O && tc && vc && 0 < vc.length && vc.forEach(function (a) {
      a.style.marginTop = 0;
    });
    tc = !1;
    uc = "";
    vc = [];
    sc = !1;
    a ? b.innerHTML = a : b.innerHTML = yc();
    G(b);
    document.head.appendChild(b);
  }

  function yc() {
    var a = "",
        b = "";
    document.body.style.transition = "";
    document.getElementById("branch-banner-iframe") && (document.getElementById("branch-banner-iframe").style.transition = "");
    rc || (a = "body { -webkit-transition: all 0.375s ease; }\n", document.body.style.transition = "all 00.375s ease", b = "-webkit-transition: all 0.25s ease; transition: all 00.25s ease;");
    return (a ? a : "") + ("#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width:100%; left: 0; right: 0; border: 0; height: " + P + "; z-index: 99999; " + b + " }\n#branch-banner-iframe { position: " + ac + "; }\n@media only screen and (orientation: landscape) { body { " + ("top" === O ? "margin-top: " : "margin-bottom: ") + (bc ? fc + "px" : P) + "; }\n#branch-banner-iframe { height: " + (bc ? fc + "px" : P) + "; }");
  }

  function zc(a, b) {
    Nb(document.body, "branch-banner-is-active");
    bc && "fixed" === ac && Nb(document.body, "branch-banner-no-scroll");
    setTimeout(function () {
      b ? (a.style.top = null, a.style.bottom = null) : "top" === O ? a.style.top = "0" : "bottom" === O && (T && T.journey_link_data && !T.journey_link_data.safeAreaRequired ? a.style.bottom = "0" : (dc = !0, document.getElementById("branch-banner-iframe").style.transition = "all 0s", Ac(!1, !0), window.addEventListener("resize", Bc), window.addEventListener("scroll", Cc)));
      N(S, "didShowJourney", T);
      pc = !0;
    }, 20);
  }

  function Bc() {
    dc && Ac(!1, !1);
  }

  function Cc() {
    dc && (window.pageYOffset > window.innerHeight ? Ac(!0, !1) : Ac(!1, !1));
  }

  function Ac(a, b) {
    var c = document.getElementById("branch-banner-iframe"),
        d = c.offsetHeight,
        e = c.offsetTop,
        f = window.innerHeight;
    b && window.pageYOffset ? c.style.bottom = "0" : a ? c.style.top = f - d + d / 2 + "px" : f - e != d && (c.style.top = "" + (f - d) + "px");
  }

  function Dc(a) {
    a = a.globalDismissPeriod;

    if ("number" === typeof a) {
      if (-1 === a) a = !0;else {
        var b = new Date();
        a = b.setSeconds(b.getSeconds() + a);
      }
      return a;
    }
  }

  function Ec(a, b, c, d, e, f, k) {
    var g = U;
    d && e && (Array.prototype.forEach.call(e.contentWindow.document.querySelectorAll("#branch-mobile-action"), function (a) {
      a.addEventListener("click", function () {
        N(S, "didClickJourneyCTA", T);
        sc = !0;
        d();
        Fc(e);
      });
    }), Gc(".branch-banner-continue", "didClickJourneyContinue", c, e, a, b, f, k, g), Gc(".branch-banner-close", "didClickJourneyClose", c, e, a, b, f, k, g));
  }

  function Gc(a, b, c, d, e, f, k, g, l) {
    Array.prototype.forEach.call(d.contentWindow.document.querySelectorAll(a), function (a) {
      a.addEventListener("click", function () {
        Ic(b, c, d, e, f, k, g, l);
      });
    });
  }

  function Jc(a, b, c) {
    var d = a.get("journeyDismissals", !0),
        d = d ? n(d) : {};
    d[c] = {
      view_id: b,
      dismiss_time: Date.now()
    };
    a.set("journeyDismissals", q(d), !0);
  }

  function Kc(a) {
    var b = {},
        c = C();
    c && 0 < Object.keys(c).length && (b.hosted_deeplink_data = c);
    return a.I(Lc(null, b), null, S, !0);
  }

  function Ic(a, b, c, d, e, f, k, g) {
    var l = k ? 0 : Dc(f);
    N(S, a, T);
    sc = !0;
    Fc(c);
    if (!k) if (void 0 !== l && b.set("globalJourneysDismiss", l, !0), Jc(b, d, e), f.dismissRedirect) window.location = f.dismissRedirect;else {
      var m = function m() {
        S.removeListener(m);
        var a = Kc(g);
        S.b(wb, a, function (b, c) {
          !b && "object" === typeof c && c.template && g.N(c, null, !1) && g.J(c.template, a, a.branch_view_id || c.event_data.branch_view_data.id, c.event_data.branch_view_data, !1, c.journey_link_data);
        });
      };

      S.addListener("branch_internal_event_didCloseJourney", m);
    }
  }

  function Lc(a, b) {
    return z({
      url: a && a.url || Ca(),
      user_agent: navigator.userAgent,
      language: navigator.language,
      screen_width: screen.width || -1,
      screen_height: screen.height || -1,
      window_device_pixel_ratio: window.devicePixelRatio || 1
    }, b || {});
  }

  function Fc(a, b) {
    if (rc && !qc) {
      document.body.style.transition = "all 00.375s ease";
      document.getElementById("branch-banner-iframe").style.transition = "all 00.25s ease";
      var c = document.getElementById("branch-iframe-css").innerHTML + "\n";
      document.getElementById("branch-iframe-css").innerHTML = "";
      document.getElementById("branch-iframe-css").innerHTML = c + "body { -webkit-transition: all 0.375s ease; }\n#branch-banner-iframe { -webkit-transition: all 0.25s ease; }\n";
    }

    "top" === O ? a.style.top = "-" + P : "bottom" === O && (a.style.bottom = "-" + P);
    N(S, "willCloseJourney", T);
    setTimeout(function () {
      M(a);
      M(document.getElementById("branch-css"));
      M(document.getElementById("branch-iframe-css"));
      M(document.getElementById("branch-journey-cta"));
      (!qc || sc) && R && 0 < R.length ? R.forEach(function (a) {
        a.style.marginTop = 0;
      }) : (tc = qc, uc = O, vc = R);
      "top" === O ? document.body.style.marginTop = gc : "bottom" === O && (document.body.style.marginBottom = hc);
      Ob("branch-banner-is-active");
      Ob("branch-banner-no-scroll");
      dc && (dc = !1, window.removeEventListener("resize", Bc), window.removeEventListener("scroll", Cc));
      N(S, "didCloseJourney", T);
      b || N(S, "branch_internal_event_didCloseJourney", T);
      pc = !1;
    }, qc ? 0 : 270);
  }

  function Mc(a) {
    var b = {
      banner_id: Zb
    };

    if (a && "object" === typeof a && 0 < Object.keys(a).length) {
      var c = ["browser_fingerprint_id", "app_id", "source", "open_app", "link_click_id"];
      if (a && "object" === typeof a && !Array.isArray(a) && 0 < Object.keys(a).length && c && Array.isArray(c) && 0 < c.length) for (var d in a) {
        a.hasOwnProperty(d) && -1 < c.indexOf(d) && delete a[d];
      }
      b.journey_link_data = {};
      z(b.journey_link_data, a);
    }

    T = b;
  }

  ;
  var U = {};

  function Nc(a, b) {
    var c = b ? "OPEN" : "GET",
        d = a,
        e = wc(d);
    e && e.bannerHeight && e.position && e.sticky ? (P = e.bannerHeight, O = e.position, ac = e.sticky) : (d = d.match(mc)) ? (O = "top", (d = d[1].match(nc)) && (P = d[1]), ac = "absolute") : (O = "bottom", ac = "fixed");
    if (-1 !== P.indexOf("vh") || -1 !== P.indexOf("%")) d = P.indexOf("vh") ? P.slice(0, -2) : P.slice(0, -1), P = d / 100 * ec + "px", 100 > d ? cc = !0 : bc = !0;

    if (d = wc(a)) {
      var f;
      b && d && d.ctaText && d.ctaText.has_app ? f = d.ctaText.has_app : d && d.ctaText && d.ctaText.no_app && (f = d.ctaText.no_app);
      c = f;
      R = [];
      if (d && d.injectorSelector && (f = document.querySelectorAll(d.injectorSelector))) for (d = 0; d < f.length; d++) {
        R.push(f[d].parentElement);
      }
    }

    f = (f = a.match(kc)) ? f[1] : void 0;
    if (d = a.match(jc)) d = d[1], e = document.createElement("script"), e.id = "branch-journey-cta", G(e), e.innerHTML = d, document.body.appendChild(e);
    d = (d = a.match(lc)) ? d[1] : void 0;
    var e = a,
        k = e.match(ic),
        g = e.match(jc),
        l = e.match(kc),
        m = e.match(lc);
    k && (e = e.replace(ic, ""));
    g && (e = e.replace(jc, ""));
    l && (e = e.replace(kc, ""));
    m && (e = e.replace(lc, ""));
    a = e;
    e = document.createElement("iframe");
    e.src = "about:blank";
    e.style.overflow = "hidden";
    e.scrolling = "no";
    e.id = "branch-banner-iframe";
    e.className = "branch-animation";
    e.title = "Branch Banner";
    e.setAttribute("aria-label", "Branch Banner");
    G(e);
    document.body.appendChild(e);
    k = A();
    k = '<html><head></head><body class="' + ("ios" === k || "ipad" === k ? "branch-banner-ios" : "android" === k ? "branch-banner-android" : "branch-banner-desktop") + '">' + a + "</body></html>";
    e.contentWindow.document.open();
    e.contentWindow.document.write(k);
    e.contentWindow.document.close();
    xc(d);
    k = document.createElement("style");
    k.type = "text/css";
    k.id = "branch-css";
    k.innerHTML = f;
    G(k);
    f = e.contentWindow.document;
    f.head.appendChild(k);

    if (cc || bc) {
      var p = f.getElementsByClassName("branch-banner-content")[0];
      p && (p.style.height = P);
    }

    "top" === O ? e.style.top = "-" + P : "bottom" === O && (e.style.bottom = "-" + P);

    try {
      var p = f.getElementsByClassName("branch-banner-content")[0],
          t = window.getComputedStyle(p).getPropertyValue("background-color").split(", ");
      t[3] && !parseFloat(t[3]) && (e.style.boxShadow = "none");
    } catch (Q) {}

    e.contentWindow.document.getElementById("branch-mobile-action").innerHTML = c;
    N(S, "willShowJourney", T);
    zc(e, d);
    return e;
  }

  U.N = function (a, b, c) {
    if (document.getElementById("branch-banner") || document.getElementById("branch-banner-iframe") || document.getElementById("branch-banner-container") || !A() || !a.event_data || !a.template) return !1;
    if (c) return !0;
    (a = !a.event_data.branch_view_data.id || b && b.no_journeys) || (a = S, b = a.c.get("globalJourneysDismiss", !0), !0 === b || b > Date.now() ? a = !0 : (a.c.remove("globalJourneysDismiss", !0), a = !1));
    return a ? (U.za = 1, !1) : !0;
  };

  U.ja = function (a) {
    S.b(vb, {
      event: "pageview",
      journey_displayed: !0,
      audience_rule_id: a.audience_rule_id,
      branch_view_id: a.branch_view_id
    }, function () {});
  };

  U.J = function (a, b, c, d, e, f) {
    Zb = c;
    Mc(f);
    var k = d.audience_rule_id;
    (f = document.getElementById("branch-iframe-css")) && f.parentElement.removeChild(f);
    f = document.createElement("div");
    f.id = "branch-banner";
    document.body.insertBefore(f, null);
    Nb(f, "branch-banner-is-active");
    var g = !1,
        l = b.callback_string,
        m = null,
        p = null,
        t = S.c;

    if (a) {
      var Q = wc(a) || {},
          Hc = window.setTimeout(function () {
        window[l] = function () {};
      }, pa);

      window[l] = function (a) {
        window.clearTimeout(Hc);
        g || (p = a, Ec(c, k, t, p, m, Q, e));
      };

      oc = m = Nc(a, b.has_app_websdk);

      if (null === m) {
        g = !0;
        return;
      }

      Ec(c, k, t, p, m, Q, e);
      qa && (u["journey-load-time"] = (Date.now() - window.performance.timing.navigationStart).toString());
    }

    document.body.removeChild(f);
    v || e || U.ja(d);
  };

  U.I = function (a, b, c, d) {
    S = c;
    b || (b = {});
    a || (a = {});
    rc = b.disable_entry_animation || !1;
    qc = b.disable_exit_animation || !1;
    var e = z({}, c.H),
        f = L(c.c) || {},
        k = f.hasOwnProperty("has_app") ? f.has_app : !1,
        g = c.c.get("journeyDismissals", !0),
        l = (b.user_language || Oa() || "en").toLowerCase() || null,
        m = $a(V(c)),
        p;
    (p = b.branch_view_id) || (p = "_branch_view_id".replace(/[\[\]]/g, "\\$&"), p = (p = new RegExp("[?&]" + p + "(=([^&#]*)|&|#|$)").exec(Ca())) && p[2] ? decodeURIComponent(p[2].replace(/\+/g, " ")) : "");
    p = p || null;
    c = b.make_new_link ? null : Ea(V(c));
    e.event = d ? "dismiss" : "pageview";
    e.metadata = a;
    e = E(e, "initial_referrer", m);
    e = E(e, "branch_view_id", p);
    e = E(e, "no_journeys", b.no_journeys);
    e = E(e, "is_iframe", x());
    e = E(e, "journey_dismissals", g);
    e.user_language = l;
    e.open_app = b.open_app || !1;
    e.has_app_websdk = k;
    e.feature = "journeys";
    e.callback_string = "branch_view_callback__" + $b++;
    e.data || (e.data = {});
    e.data = z(C(), e.data);
    e.data = z(Ba(f || {}), e.data);
    c && (e.data.link_click_id = c);
    (a = f.data ? JSON.parse(f.data) : null) && a["+referrer"] && (e.data["+referrer"] = a["+referrer"]);
    return e = Da(e);
  };

  var W = {
    androidAppIndexingTagsPresent: !1,
    iosAppIndexingTagsPresent: !1,
    androidDetailsComplete: !1,
    iosDetailsComplete: !1
  },
      X = {};

  function Oc(a) {
    var b;
    "android" === a && W.androidDetailsComplete && (b = "android-app://" + X.androidPackageName + "/" + X.androidURL, b = Pc(b), Qc(b));
    "ios" === a && W.iosDetailsComplete && (b = "ios-app://" + X.iosAppId + "/" + X.iosURL, b = Pc(b), Qc(b));
  }

  function Pc(a) {
    var b = {
      "~channel": "Firebase App Indexing",
      "~feature": "Auto App Indexing",
      $canonical_url: Ca()
    };
    if ("object" === typeof X.data) for (var c in X.data) {
      X.data.hasOwnProperty(c) && !b.hasOwnProperty(c) && (b[c] = X.data[c]);
    }
    return a + (-1 < a.indexOf("?") ? "&" : "?") + "link_click_id=a-" + btoa(q(b));
  }

  function Qc(a) {
    var b = document.createElement("link");
    b.setAttribute("rel", "alternate");
    b.setAttribute("href", a);
    document.head.appendChild(b);
  }

  function Rc(a) {
    "android" === a && "string" === typeof X.androidPackageName && "string" === typeof X.androidURL && (W.androidDetailsComplete = !0, Oc("android"));
    "ios" === a && "string" === typeof X.iosAppId && "string" === typeof X.iosURL && (W.iosDetailsComplete = !0, Oc("ios"));
  }

  function Sc(a) {
    for (var b = document.getElementsByTagName("meta"), c = 0; c < b.length; c++) {
      var d = b[c];
      "ios" === a && "al:ios:app_store_id" === d.getAttribute("property") && (X.iosAppId = d.getAttribute("content"));
      "ios" === a && "al:ios:url" === d.getAttribute("property") && (X.iosURL = d.getAttribute("content").replace("://", "/"));
      "android" === a && "al:android:package" === d.getAttribute("property") && (X.androidPackageName = d.getAttribute("content"));
      "android" === a && "al:android:url" === d.getAttribute("property") && (X.androidURL = d.getAttribute("content").replace("://", "/"));
    }

    Rc(a);
  }

  ;
  var Tc;

  function Y(a, b, c) {
    return function () {
      var d = this,
          e,
          f,
          k = arguments[arguments.length - 1];
      a && "function" === typeof k ? (e = Array.prototype.slice.call(arguments, 0, arguments.length - 1) || [], f = k) : (f = function f() {}, e = Array.prototype.slice.call(arguments));
      d.$(function (g) {
        function k(b, c) {
          try {
            if (b && !a) throw b;
            1 === a ? f(b) : 2 === a && f(b, c);
          } finally {
            g();
          }
        }

        if (!c) {
          if (1 === d.j) return k(Error(w("Branch SDK initialization pending and a Branch method was called outside of the queue order")), null);
          if (2 === d.j) return k(Error(w("Branch SDK initialization failed, so further methods cannot be called", d.i, d.l)), null);
          if (0 === d.j || !d.j) return k(Error(w("Branch SDK not initialized")), null);
        }

        e.unshift(k);
        b.apply(d, e);
      });
    };
  }

  function Z() {
    if (!(this instanceof Z)) return Tc || (Tc = new Z()), Tc;
    this.$ = ma();
    this.c = new zb(["session", "cookie", "pojo"]);
    this.ca = new Gb();
    this.g = [];
    this.V = "web2.52.3";
    this.i = this.j = 0;
    this.l = null;
  }

  Z.prototype.b = function (a, b, c) {
    this.U && (b.app_id = this.U);
    this.h && (b.branch_key = this.h);
    (a.a && a.a.session_id || a.f && a.f.session_id) && this.G && (b.session_id = this.G);
    (a.a && a.a.identity_id || a.f && a.f.identity_id) && this.v && (b.identity_id = this.v);
    (a.a && a.a.link_click_id || a.f && a.f.link_click_id) && this.Z && (b.link_click_id = this.Z);
    (a.a && a.a.sdk || a.f && a.f.sdk) && this.V && (b.sdk = this.V);
    (a.a && a.a.browser_fingerprint_id || a.f && a.f.browser_fingerprint_id) && this.B && (b.browser_fingerprint_id = this.B);
    v && (b.tracking_disabled = v);
    return Mb(this.ca, a, b, this.c, function (a, b) {
      c(a, b);
    });
  };

  function V(a) {
    var b = L(a.c);
    return (b = b && b.referring_link) ? b : (a = a.c.get("click_id")) ? "https://bnc.lt/c/" + a : null;
  }

  function N(a, b, c) {
    for (var d = 0; d < a.g.length; d++) {
      a.g[d].event && a.g[d].event !== b || a.g[d].listener(b, c);
    }
  }

  Z.prototype.init = Y(2, function (a, b, c) {
    function d() {
      var a, b;
      "undefined" !== typeof document.hidden ? (a = "hidden", b = "visibilitychange") : "undefined" !== typeof document.mozHidden ? (a = "mozHidden", b = "mozvisibilitychange") : "undefined" !== typeof document.msHidden ? (a = "msHidden", b = "msvisibilitychange") : "undefined" !== typeof document.webkitHidden && (a = "webkitHidden", b = "webkitvisibilitychange");
      b && !g.da && (g.da = !0, document.addEventListener(b, function () {
        document[a] || (f(null), "function" === typeof g.s && g.s());
      }, !1));
    }

    function e(b, d) {
      d && (d = k(d), v || za(g.c, d, p), g.j = 3, d.data_parsed = d.data && 0 !== d.data.length ? n(d.data) : {});
      if (b) return g.j = 2, g.i || (g.i = 1, g.l = b.message), a(b, d && Aa(d));

      try {
        a(b, d && Aa(d));
      } catch (Zc) {} finally {
        g.renderFinalize();
      }

      var e = Ua(),
          f = F(c.metadata, "object") ? c.metadata : null;
      f && (f = ab(e.hosted_deeplink_data, f)) && 0 < Object.keys(f).length && (e.hosted_deeplink_data = f);
      var m = U.I(Lc(c, e), c, g, !1);
      g.renderQueue(function () {
        g.b(vb, m, function (a, b) {
          if (!a && "object" === typeof b) {
            var d = m.branch_view_id ? !0 : !1;
            U.N(b, c, d) ? U.J(b.template, m, m.branch_view_id || b.event_data.branch_view_data.id, b.event_data.branch_view_data, d, b.journey_link_data) : ((b.auto_branchify || !l && Ka("branchify_url") && V(g)) && this.branch.deepview({}, {
              make_new_link: !1,
              open_app: !0,
              auto_branchify: !0
            }), N(S, "willNotShowJourney"));
          }

          v && (ua = !0);
        });
      });
    }

    function f(a) {
      var b = {
        sdk: "2.52.3",
        branch_key: g.h
      },
          c = L(g.c) || {},
          d = L(g.c, !0) || {};
      d.browser_fingerprint_id && (b._t = d.browser_fingerprint_id);
      Ja() || g.b(cb, b, function (a, b) {
        a && (g.i = 3, g.l = a.message);
        b && (c.browser_fingerprint_id = b);
      });
      g.b(qb, {
        browser_fingerprint_id: c.browser_fingerprint_id
      }, function (b, d) {
        b && (g.i = 4, g.l = b.message);
        b || !d || c.has_app || (c.has_app = !0, Fb(g.c, c), N(g, "didDownloadApp"));
        a && a(null, c);
      });
    }

    function k(a) {
      a.link_click_id && (g.Z = a.link_click_id.toString());
      a.session_id && (g.G = a.session_id.toString());
      a.identity_id && (g.v = a.identity_id.toString());
      a.link && (g.M = a.link);

      if (a.referring_link) {
        var b = a.referring_link;
        a.referring_link = b ? "http" !== b.substring(0, 4) ? "https://bnc.lt" + b : b : null;
      }

      !a.click_id && a.referring_link && (a.click_id = Ea(a.referring_link));
      g.B = a.browser_fingerprint_id;
      return a;
    }

    qa && (u["init-began-at"] = (Date.now() - window.performance.timing.navigationStart).toString());
    var g = this;
    g.j = 1;
    -1 < b.indexOf("key_") ? g.h = b : g.U = b;
    c = c && F(c, "object") ? c : {};
    na = (g.F = c) && c.retries && Number.isInteger(c.retries) ? c.retries : na;
    oa = c && c.retry_delay && Number.isInteger(c.retry_delay) ? c.retry_delay : oa;
    pa = c && c.timeout && Number.isInteger(c.timeout) ? c.timeout : pa;
    r = c && c.nonce ? c.nonce : r;
    v = c && c.tracking_disabled && !0 === c.tracking_disabled ? !0 : !1;
    ua = !1;
    v && ya(g);
    b = L(g.c);
    var l = c && "undefined" !== typeof c.branch_match_id && null !== c.branch_match_id ? c.branch_match_id : null,
        m = l || Ka("_branch_match_id") || Fa(),
        p = !b || !b.identity_id;
    g.A = !!g.c.get("branch_view_enabled");
    if (b && b.session_id && !m && !Ka("branchify_url")) Fb(g.c, {
      data: ""
    }), Fb(g.c, {
      referring_link: ""
    }), d(), f(e);else {
      b = {
        sdk: "2.52.3",
        branch_key: g.h
      };
      var t = L(g.c, !0) || {};
      t.browser_fingerprint_id && (b._t = t.browser_fingerprint_id);
      Ja() ? g.b(bb, {
        link_identifier: m,
        browser_fingerprint_id: m || t.browser_fingerprint_id,
        alternative_browser_fingerprint_id: t.browser_fingerprint_id,
        options: c,
        initial_referrer: $a(V(g)),
        current_url: x() && Ga() ? window.top.location.href : window.location.href
      }, function (a, b) {
        a && (g.i = 2, g.l = a.message);
        a || "object" !== typeof b || (b.branch_view_enabled && (g.A = !!b.branch_view_enabled, g.c.set("branch_view_enabled", g.A)), m && (b.click_id = m));
        d();
        e(a, b);
      }) : g.b(cb, b, function (a, b) {
        if (a) return g.i = 3, g.l = a.message, e(a, null);
        g.b(bb, {
          link_identifier: m,
          browser_fingerprint_id: m || b,
          alternative_browser_fingerprint_id: t.browser_fingerprint_id,
          options: c,
          initial_referrer: $a(V(g)),
          current_url: x() && Ga() ? window.top.location.href : window.location.href
        }, function (a, b) {
          a && (g.i = 2, g.l = a.message);
          a || "object" !== typeof b || (b.branch_view_enabled && (g.A = !!b.branch_view_enabled, g.c.set("branch_view_enabled", g.A)), m && (b.click_id = m));
          d();
          e(a, b);
        });
      });
    }
  }, !0);
  Z.prototype.renderQueue = Y(0, function (a, b) {
    this.aa ? b() : (this.m = this.m || [], this.m.push(b));
    a(null, null);
  });
  Z.prototype.renderFinalize = Y(2, function (a) {
    this.m && 0 < this.m.length && (this.m.forEach(function (a) {
      a.call(this);
    }), delete this.m);
    this.aa = !0;
    a(null, null);
  });
  Z.prototype.data = Y(2, function (a) {
    var b = Aa(L(this.c));
    b.referring_link = V(this);
    b.data_parsed = b.data && 0 !== b.data.length ? n(b.data) : {};
    a(null, b);
  });
  Z.prototype.first = Y(2, function (a) {
    a(null, Aa(L(this.c, !0)));
  });
  Z.prototype.setIdentity = Y(2, function (a, b) {
    var c = this;
    this.b(jb, {
      identity: b
    }, function (d, e) {
      d && a(d);
      e = e || {};
      c.v = e.identity_id ? e.identity_id.toString() : null;
      c.M = e.link;
      c.C = b;
      e.referring_data_parsed = e.referring_data ? n(e.referring_data) : null;
      Fb(c.c, e);
      a(null, e);
    });
  });
  Z.prototype.logout = Y(1, function (a) {
    var b = this;
    this.b(ib, {}, function (c, d) {
      c && a(c);
      d = d || {};
      d = {
        data_parsed: null,
        data: null,
        referring_link: null,
        click_id: null,
        link_click_id: null,
        identity: null,
        session_id: d.session_id,
        identity_id: d.identity_id,
        link: d.link,
        device_fingerprint_id: b.ga || null
      };
      b.M = d.link;
      b.G = d.session_id;
      b.v = d.identity_id;
      b.C = d.identity;
      Fb(b.c, d);
      a(null);
    });
  });
  Z.prototype.getBrowserFingerprintId = Y(2, function (a) {
    var b = L(this.c, !0) || {};
    a(null, b.browser_fingerprint_id || null);
  });
  Z.prototype.crossPlatformIds = Y(2, function (a) {
    this.b(xb, {
      user_data: q(Za(this))
    }, function (b, c) {
      return a(b || null, c && c.user_data || null);
    });
  });
  Z.prototype.lastAttributedTouchData = Y(2, function (a, b) {
    b = F(b, "number") ? b : null;
    var c = Za(this);
    E(c, "attribution_window", b);
    this.b(yb, {
      user_data: q(c)
    }, function (b, c) {
      return a(b || null, c || null);
    });
  });
  Z.prototype.track = Y(1, function (a, b, c, d) {
    c = c || {};
    d = d || {};
    r = d.nonce ? d.nonce : r;

    if ("pageview" === b) {
      (b = ab(C(), c)) && 0 < Object.keys(b).length && (c.hosted_deeplink_data = b);
      var e = U.I(Lc(d, c), d, this, !1);
      this.b(vb, e, function (b, c) {
        if (!b && "object" === typeof c) {
          var f = e.branch_view_id ? !0 : !1;
          U.N(c, d, f) ? U.J(c.template, e, e.branch_view_id || c.event_data.branch_view_data.id, c.event_data.branch_view_data, f, c.journey_link_data) : N(S, "willNotShowJourney");
        }

        "function" === typeof a && a.apply(this, arguments);
      });
    } else this.b(rb, {
      event: b,
      metadata: z({
        url: Ca(),
        user_agent: navigator.userAgent,
        language: navigator.language
      }, c),
      initial_referrer: $a(V(this))
    }, function (b, c) {
      "function" === typeof a && a.apply(this, arguments);
    });
  });
  Z.prototype.logEvent = Y(1, function (a, b, c, d, e) {
    b = F(b, "string") ? b : null;
    c = F(c, "object") ? c : null;
    e = F(e, "string") ? e : null;
    b && -1 < Va.indexOf(b) ? (d = F(d, "array") ? d : null, c = Xa(c), this.b(tb, {
      name: b,
      user_data: q(Za(this)),
      custom_data: q(c && c.custom_data || {}),
      event_data: q(c && c.event_data || {}),
      content_items: q(d || []),
      customer_event_alias: e
    }, function (b) {
      return a(b || null);
    })) : this.b(ub, {
      name: b,
      user_data: q(Za(this)),
      custom_data: q(Ya(c || {}))
    }, function (b) {
      return a(b || null);
    });
  });
  Z.prototype.link = Y(2, function (a, b) {
    var c = Da(b),
        d = this.h;
    this.b(ob, c, function (b, f) {
      if (b) return a(b, wa(d, c));
      a(null, f && f.url);
    });
  });
  Z.prototype.sendSMS = Y(1, function (a, b, c, d) {
    function e(c) {
      f.b(eb, {
        link_url: c,
        phone: b
      }, function (b) {
        a(b || null);
      });
    }

    var f = this;
    if ("function" === typeof d) d = {};else if ("undefined" === typeof d || null === d) d = {};
    d.make_new_link = d.make_new_link || !1;
    c.channel && "app banner" !== c.channel || (c.channel = "sms");
    var k = V(f);
    k && !d.make_new_link ? e(Ea(k)) : f.b(ob, Da(c), function (b, c) {
      if (b) return a(b);
      var d = c.url;
      /(bnc.lt\/|app\.link\/)/.test(d) || (d = "https://bnc.lt/" + Na(d));
      f.b(db, {
        link_url: d,
        click: "click"
      }, function (b, c) {
        if (b) return a(b);
        e(c.click_id);
      });
    });
  });
  Z.prototype.deepview = Y(1, function (a, b, c) {
    var d = this;
    c || (c = {});
    c.deepview_type = "undefined" === typeof c.deepview_type ? "deepview" : "banner";
    b.data = z(C(), b.data);
    b = x() ? z({
      is_iframe: !0
    }, b) : b;
    b = Da(b);
    var e = wa(this.h, b);
    if (c.open_app || null === c.open_app || "undefined" === typeof c.open_app) b.open_app = !0;
    b.append_deeplink_path = !!c.append_deeplink_path;
    b.deepview_type = c.deepview_type;
    var f = V(d);
    f && !c.make_new_link && (b.link_click_id = Ea(f));
    b.banner_options = c;
    c.auto_branchify && (b.auto_branchify = !0);
    d.s = ga(this.b, d, pb, b, function (b, c) {
      if (b) return v || (d.o = function () {
        window.top.location = e;
      }), a(b);
      "function" === typeof c && (d.o = c);
      a(null);
    });
    d.s();
  });
  Z.prototype.deepviewCta = Y(1, function (a) {
    if ("undefined" === typeof this.o) return v ? a(Error("Requested operation cannot be completed since tracking is disabled"), null) : a(Error("Cannot call Deepview CTA, please call branch.deepview() first"), null);
    window.event && (window.event.preventDefault ? window.event.preventDefault() : window.event.returnValue = !1);
    N(this, "didDeepviewCTA");
    this.o();
    a();
  });
  Z.prototype.referrals = Y(2, function (a) {
    this.b(kb, {}, a);
  });
  Z.prototype.getCode = Y(2, function (a, b) {
    b.type = "credit";
    b.creation_source = b.creation_source || 2;
    this.b(fb, b, a);
  });
  Z.prototype.validateCode = Y(1, function (a, b) {
    this.b(gb, {
      code: b
    }, a);
  });
  Z.prototype.applyCode = Y(1, function (a, b) {
    this.b(hb, {
      code: b
    }, a);
  });
  Z.prototype.credits = Y(2, function (a) {
    this.b(mb, {
      branch_key: this.h,
      identity: this.C
    }, a);
  });
  Z.prototype.creditHistory = Y(2, function (a, b) {
    this.b(lb, b || {}, a);
  });
  Z.prototype.redeem = Y(1, function (a, b, c) {
    this.b(nb, {
      amount: b,
      bucket: c
    }, function (b) {
      a(b || null);
    });
  });

  Z.prototype.addListener = function (a, b) {
    "function" === typeof a && void 0 === b && (b = a, a = null);
    b && this.g.push({
      listener: b,
      event: a || null
    });
  };

  Z.prototype.removeListener = function (a) {
    a && (this.g = this.g.filter(function (b) {
      if (b.listener !== a) return b;
    }));
  };

  function Uc(a, b, c) {
    c = c || {};

    try {
      a.H = n(q(c));
    } finally {
      a.H = a.H || {};
    }

    b();
  }

  Z.prototype.setBranchViewData = Y(1, function (a, b) {
    Uc.call(null, this, a, b);
  });
  Z.prototype.closeJourney = Y(1, function (a) {
    var b = this;
    b.renderQueue(function () {
      if (oc && pc) N(b, "didCallJourneyClose", T), Fc(oc, !0);else return a("Journey already dismissed.");
    });
    a();
  });
  Z.prototype.banner = Y(1, function (a, b, c) {
    c = c || {};
    Uc.call(null, this, function () {}, c);
    "undefined" === typeof b.showAgain && "undefined" !== typeof b.forgetHide && (b.showAgain = b.forgetHide);
    var d = {
      icon: D(b.icon) || "",
      title: D(b.title) || "",
      description: D(b.description) || "",
      L: "number" === typeof b.reviewCount && 0 < b.reviewCount ? Math.floor(b.reviewCount) : null,
      w: "number" === typeof b.rating && 5 >= b.rating && 0 < b.rating ? Math.round(2 * b.rating) / 2 : null,
      ma: D(b.openAppButtonText) || "View in app",
      ia: D(b.downloadAppButtonText) || "Download App",
      qa: D(b.sendLinkText) || "Send Link",
      oa: D(b.phonePreviewText) || "(999) 999-9999",
      D: "undefined" === typeof b.iframe ? !0 : b.iframe,
      T: "undefined" === typeof b.showiOS ? !0 : b.showiOS,
      sa: "undefined" === typeof b.showiPad ? !0 : b.showiPad,
      O: "undefined" === typeof b.showAndroid ? !0 : b.showAndroid,
      P: "undefined" === typeof b.showBlackberry ? !0 : b.showBlackberry,
      S: "undefined" === typeof b.showWindowsPhone ? !0 : b.showWindowsPhone,
      R: "undefined" === typeof b.showKindle ? !0 : b.showKindle,
      ra: "undefined" === typeof b.showDesktop ? !0 : b.showDesktop,
      ha: !!b.disableHide,
      K: "number" === typeof b.forgetHide ? b.forgetHide : !!b.forgetHide,
      pa: "undefined" === typeof b.respectDNT ? !1 : b.respectDNT,
      position: b.position || "top",
      ea: b.customCSS || "",
      la: "undefined" === typeof b.mobileSticky ? !1 : b.mobileSticky,
      fa: "undefined" === typeof b.desktopSticky ? !0 : b.desktopSticky,
      va: b.buttonBorderColor || "",
      ta: b.buttonBackgroundColor || "",
      xa: b.buttonFontColor || "",
      wa: b.buttonBorderColorHover || "",
      ua: b.buttonBackgroundColorHover || "",
      ya: b.buttonFontColorHover || "",
      ka: !!b.make_new_link,
      na: !!b.open_app,
      X: !!b.immediate,
      ba: !!b.append_deeplink_path
    };
    "undefined" !== typeof b.showMobile && (d.T = b.showMobile, d.O = b.showMobile, d.P = b.showMobile, d.S = b.showMobile, d.R = b.showMobile);
    c.data = z(C(), c.data);
    var e = this;
    e.renderQueue(function () {
      e.W = Yb(e, d, c, e.c);
    });
    a();
  });
  Z.prototype.closeBanner = Y(0, function (a) {
    var b = this;
    b.renderQueue(function () {
      b.W && (N(b, "willCloseBanner"), b.W(function () {
        N(b, "didCloseBanner");
      }));
    });
    a();
  });
  Z.prototype.autoAppIndex = Y(1, function (a, b) {
    b = b || {};
    var c = document.getElementsByTagName("link"),
        d = c.length;
    if (d) for (var e = 0; e < d; e++) {
      var f = c[e],
          k = f.href;
      k && (k.includes("ios-app") && (W.iosAppIndexingTagsPresent = !0, f.setAttribute("href", Pc(k))), k.includes("android-app") && (W.androidAppIndexingTagsPresent = !0, f.setAttribute("href", Pc(k))));
    }
    X = b;
    W.androidAppIndexingTagsPresent || (Rc("android"), W.androidDetailsComplete || Sc("android"));
    W.iosAppIndexingTagsPresent || (Rc("ios"), W.iosDetailsComplete || Sc("ios"));
    W.iosDetailsComplete || W.androidDetailsComplete ? a(null) : a("Firebase App Indexing tags were not added to your webpage. Please check your configuration.");
  });
  Z.prototype.trackCommerceEvent = Y(1, function (a, b, c, d) {
    var e = this;
    e.renderQueue(function () {
      var f = Ta(b, c);
      if (f) return a(Error(f));
      e.b(sb, {
        event: b,
        metadata: z({
          url: document.URL,
          user_agent: navigator.userAgent,
          language: navigator.language
        }, d || {}),
        initial_referrer: $a(V(e)),
        commerce_data: c
      }, function (b) {
        a(b || null);
      });
    });
    a();
  });
  Z.prototype.disableTracking = Y(1, function (a, b) {
    if (!1 === b || "false" === b) ua = v = !1, this.h && this.F && (!0 === this.F.tracking_disabled && delete this.F.tracking_disabled, this.init(this.h, this.F));else if (void 0 === b || !0 === b || "true" === b) ya(this), ua = v = !0, this.closeBanner(), this.closeJourney();
    a();
  });
  var Vc = new Z();
  if (window.branch && window.branch._q) for (var Wc = window.branch._q, Xc = 0; Xc < Wc.length; Xc++) {
    var Yc = Wc[Xc];
    Vc[Yc[0]].apply(Vc, Yc[1]);
  }
  "function" === typeof define && define.amd ? define("branch", function () {
    return Vc;
  }) : "object" === typeof exports && (module.exports = Vc);
  window && (window.branch = Vc);
})();